import React, {Component} from 'react';
import './App.css';
import {BrowserRouter as Router, Link, Redirect, Route, Switch, withRouter} from 'react-router-dom';
import KierowcyContainer from "./modules/konfiguracja/zasobyConfig/kierowcy/KierowcyContainer";
import PojazdyContainer from "./modules/konfiguracja/zasobyConfig/pojazdy/PojazdyContainer";
import EkipyContainer from "./modules/konfiguracja/zasobyConfig/ekipy/EkipyContainer";
import MiejscowosciContainer from "./modules/konfiguracja/trasyConfig/miejscowosci/MiejscowosciContainer";
import PrzystankiContainer from "./modules/konfiguracja/trasyConfig/przystanki/PrzystankiContainer";
import TrasyContainer from "./modules/konfiguracja/trasyConfig/trasy/TrasyContainer";
import DefinicjeContainer from "./modules/konfiguracja/trasyConfig/defiicje/DefinicjeContainer";
import DefinicjeTrasContainer from "./modules/konfiguracja/trasyConfig/definicjeTras/DefinicjeTrasContainer";
import KalendarzeContainer from "./modules/konfiguracja/rozkladConfig/kalendarze/KalendarzeContainer";
import DefinicjaGodzinyStartowejContainer
    from "./modules/konfiguracja/rozkladConfig/definicjeGodzinStartowychjDlaTrasy/DefinicjaGodzinyStartowejContainer";
import RozkladContainer from "./modules/konfiguracja/rozkladConfig/rozklad/RozkladContainer";
import {loadProgressBar} from 'axios-progress-bar'
import 'axios-progress-bar/dist/nprogress.css';
import axios from "axios";
import {NotificationContainer, NotificationManager} from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import moment from "moment";
import DataFormat from "./utilities/DateAndTimeFormat";
import KalendarzDoDatyService from "./modules/konfiguracja/rozkladConfig/kalendarze/przypisanieKalendarzaDoDaty/KalendarzDoDatyService";
import RodzajKalendarzyService from "./modules/konfiguracja/rozkladConfig/kalendarze/rodzajeKalendarzy/RodzajKalendarzyService";
import LogowanieContainer from "./modules/logowanie/LogowanieContainer";
import CenyBiletowContainer from "./modules/konfiguracja/biletyConfig/cenyBiletow/CenyBiletowContainer";
import acc from 'accounting';
import ZnizkiContainer from "./modules/konfiguracja/biletyConfig/znizki/ZnizkiContainer"
import PromocjeContainer from "./modules/konfiguracja/biletyConfig/promocje/PromocjeContainer";
import ObsadaContainer from "./modules/konfiguracja/rozkladConfig/obsada/ObsadaContainer";
import DostepContainer from "./modules/administracja/dostep/DostepContainer";
import HomeContainer from "./modules/home/HomeContainer";
import LogowanieService from "./modules/logowanie/LogowanieService";
import accessConfig from "./utilities/accessConfig/accessConfig";
import KlienciContainer from "./modules/klienciConfig/klienci/KlienciContainer";
import SzukajContainer from "./modules/konfiguracja/rozkladConfig/szukaj/SzukajContainer";
import FormularzContainer from "./modules/konfiguracja/wynajemConfig/formularz/FormularzContainer";
import KalendarzContainer from "./modules/konfiguracja/wynajemConfig/kalendarz/KalendarzContainer";
import ZarzadzanieContainer from "./modules/konfiguracja/wynajemConfig/zarzadzanie/ZarzadzanieContainer";
import EkipaContainer from "./modules/konfiguracja/zasobyConfig/ekipa/EkipaContainer";
import BiletyJednorazoweContainer from "./modules/konfiguracja/biletyConfig/biletyJednorazowe/BiletyJednorazoweContainer";
import BiletyMiesieczneContainer from "./modules/konfiguracja/biletyConfig/biletyMiesieczne/BiletyMiesieczneContainer";
import DodajBiletMiesiecznyContainer from "./modules/konfiguracja/biletyConfig/dodajBiletMiesieczny/DodajBiletMiesiecznyContainer";
import EPrzystankiContainer from "./modules/konfiguracja/trasyConfig/ePrzystanki/EPrzystankiContainer";
import EplatnosciContainer from "./modules/konfiguracja/biletyConfig/eplatnosci/EplatnosciContainer";
import PracownicyContainer from "./modules/administracja/pracownicy/PracownicyContainer";
import KartyContainer from "./modules/klienciConfig/karty/KartyContainer";
import KonfiguracjaContainer from "./modules/administracja/konfiguracja/KonfiguracjaContainer";
import SprzedazJednorazowychContainer from "./modules/raporty/SprzedazJednorazowych/SprzedazJednorazowychContainer";
import OthersUtilities from "./utilities/othersUtilities/OthersUtilities";
import RozliczenieKursowContainer from "./modules/raporty/RozliczenieKursow/RozliczenieKursowContainer";
import NewsletterContainer from "./modules/komunikaty/newsletter/NewsletterContainer";
import OcenyContainer from "./modules/klienciConfig/oceny/OcenyContainer";
import EBOKContainer from "./modules/klienciConfig/eBOK/EBOKContainer";
import SprzedazMiesiecznychContainer from "./modules/raporty/SprzedazMiesiecznych/SprzedazMiesiecznychContainer";
import EBOKWatekContainer from "./modules/klienciConfig/eBOK/EBOKWatekContainer";
import StronaKlientaContainer from "./modules/klienciConfig/stronaKlienta/StronaKlientaContainer";
import RozliczeniaKierowcowContainer from "./modules/raporty/RozliczeniaKierowcow/RozliczeniaKierowcowContainer";
import DodajBiletJednorazowyContainer
    from "./modules/konfiguracja/biletyConfig/dodajBiletJednorazowy/DodajBiletJednorazowyContainer";
import SprawdzKonfiguracjeContainer from "./modules/konfiguracja/rozkladConfig/sprawdzKonfiguracje/SprawdzKonfiguracjeContainer";
import SynchronizacjaDanychContainer from "./modules/administracja/synchronizacjaDanych/SynchronizacjaDanychContainer";
import LokalizacjaBusowContainer from "./modules/konfiguracja/rozkladConfig/lokalizacjaBusow/LokalizacjaBusowContainer";
import FirmyContainer from "./modules/klienciConfig/firmy/FirmyContainer";
import FakturaContainer from "./modules/fakturaModule/FakturaContainer";
import FakturyContainer from "./modules/administracja/faktury/components/FakturyContainer";
import SzablonyContainer from "./modules/administracja/szablony/SzablonyContainer";
import PowiadomieniaContainer from "./modules/komunikaty/powiadomienia/PowiadomieniaContainer";
import UrzadRozkladContainer from "./modules/urzadModule/rozklad/UrzadRozkladContainer";
import UrzadBiletyJednorazoweContainer from "./modules/urzadModule/bilety_jednorazowe/UrzadBiletyJednorazoweContainer";
import UrzadBiletyMiesieczneContainer from "./modules/urzadModule/bilety_miesieczne/UrzadBiletyMiesieczneContainer";
import UrzadRaportCennikow from "./modules/urzadModule/raport_cennikow/UrzadRaportCennikow";
import UrzadRaportPoLiniach from "./modules/urzadModule/raport_sprzedazy_po_liniach/UrzadRaportPoLiniach";
import LinieContainer from "./modules/konfiguracja/trasyConfig/linie/LinieContainer";
import PrzegladarkaContainer from "./modules/administracja/przegladarka_plikow/PrzegladarkaContainer";
import LogiContainer from "./modules/administracja/logi/LogiContainer";
import FakturyBiletyContainer from "./modules/konfiguracja/biletyConfig/fakturyBilety/FakturyBiletyContainer";
import OrlenContainer from "./modules/raporty/Orlen/OrlenContainer";
import EventyContainer from "./modules/klienciConfig/eventy/EventyContainer";
import SprzedazMiesiecznychLiniaContainer from "./modules/raporty/SprzedazMiesiecznychLinia/SprzedazMiesiecznychLiniaContainer";
import SprzedazJednorazowychLiniaContainer from "./modules/raporty/SprzedazJednorazowychPerLinia/SprzedazJednorazowychLiniaContainer";
import AplikacjaEbusDriver from "./modules/aplikacjeandroid/ebus-driver/AplikacjaEbusDriver";
import AplikacjaDlaKlientow from "./modules/aplikacjeandroid/dla-klientow/AplikacjaDlaKlientow";
import UrzadRaportSumaryczny from "./modules/urzadModule/raport_sumaryczny/UrzadRaportSumaryczny";
import UrzadRaportDoplatGrup from "./modules/urzadModule/RaportDoplatGrup/UrzadRaportDoplatGrup";
import UrzadRaportDoplatSuma from "./modules/urzadModule/raportDopatSuma/UrzadRaportDoplatSuma";
import KierowcaSerwisContainer from "./modules/administracja/kierowcaSerwis/KierowcaSerwisContainer";
import RaportZapelnieniaContainer from "./modules/raporty/RaportZapelnienia/RaportZapelnieniaContainer";
import Odbicia from "./modules/lpp/odbicia/Odbicia";
import KsiegowoscContainer from "./modules/raporty/Ksiegowosc/KsiegowoscContainer";


loadProgressBar();

acc.settings = {
    currency: {
        symbol: "zł",   // default currency symbol is '$'
        format: "%v %s", // controls output: %s = symbol, %v = value/number (can be object: see below)
        decimal: ",",  // decimal point separator
        thousand: ".",  // thousands separator
        precision: 2   // decimal places
    },
    number: {
        precision: 0,  // default precision on numbers is 0
        thousand: ",",
        decimal: "."
    }
}

axios.interceptors.response.use(function (response) {
    // Do something with response data
    return response;
}, function (error) {


    if (Boolean(error.response)) {

        console.log(error)

        console.log(error.response)

        if (error.response.data) {
            if (error.response.data.errors) {
                let str = ""
                for (let i = 0; i < error.response.data.errors.length; i++) {
                    str = str + "Błąd walidacji serwera - pole: " + error.response.data.errors[i].field + ", wiadomość: " + error.response.data.errors[i].defaultMessage + ";  "
                }
                if (str.length > 0) {
                    NotificationManager.error(str, 'Wystąpił błąd podczas próby zapisu', 10000);
                }
            }
            else if(error.response.data.message.indexOf('<e>')>-1){
                let msg =  error.response.data.message.substring((error.response.data.message.indexOf('<e>')+3),error.response.data.message.indexOf('</e>'))


                NotificationManager.error(msg, 'Wystąpił wyjątek podczas działania aplikacji!', 10000);
            }
            else{
                NotificationManager.error(error.response.data.message, 'Wystąpił błąd podczas działania aplikacji', 10000);
            }

        }else{
            NotificationManager.error('Kod błędu ' + error.response.status + ', wiadomość: ' + error.response.data.message, 'Wystąpił błąd podczas działania aplikacji', 10000);

        }

        if (error.response.status === 401 && Boolean(localStorage.getItem('obecnyUserMacelApp'))) {
            alert('Proszę się ponownie zalogować!')
            localStorage.removeItem('obecnyUserMacelApp')
            window.location.href = '/logowanie'
        }


        return Promise.reject(error);
    } else {
        console.log(error.toString())
        NotificationManager.error(error.toString(), 'Błąd aplikacji!', 10000);


        return Promise.reject(error);
    }

});


axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.headers.put['Content-Type'] = 'application/json';

if (LogowanieService.sprawdzCzyZalogowany()) {
    if (LogowanieService.pobierzZalogowanego().token.indexOf('Basic') > -1) {
        axios.defaults.headers.common.Authorization = LogowanieService.pobierzZalogowanego().token;
    }
}

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isSidebarCollapsed: true,
            kalendarze: [],
            obecnyKalendarz: null,
            collapsedLinks: [],
        };
        this.pobierzKalendarzDoDaty = this.pobierzKalendarzDoDaty.bind(this)
        this.pobierzKalendarze = this.pobierzKalendarze.bind(this)
        this.handleClickToogleSidebar = this.handleClickToogleSidebar.bind(this)
    }

    componentDidMount() {
        if (LogowanieService.sprawdzCzyZalogowany()) {
            this.pobierzKalendarze()
        }
        OthersUtilities.ustawScrollNaSidebarze()

    }

    pobierzKalendarzDoDaty() {
        let data = DataFormat.formatYYYYMMDD(moment(moment.now()));
        KalendarzDoDatyService.getDatyZKalendarzami(data, data).then(function (response) {
            if (response) {
                if (response.data.length > 0) {
                    if (this.state.kalendarze.length > 0) {
                        this.setState({obecnyKalendarz: this.state.kalendarze.find(k => k.idRk === response.data[0].idRk)})
                    }
                }
            }

        }.bind(this))
    }

    pobierzKalendarze() {
        RodzajKalendarzyService.getKalendarze().then(function (response) {
            if (response) {
                this.setState({kalendarze: response.data.content})
                this.pobierzKalendarzDoDaty()
            }
        }.bind(this))
    }

    handleClickToogleSidebar(module) {

        // moze być pare rozwinietych

        /*  let arr = this.state.collapsedLinks
          if(this.state.collapsedLinks.indexOf(module)>-1){
              // jest i trzeba usunąć
              arr.splice(arr.indexOf(module),1)
          }
          else{
              // nie ma i trzeba dodać
              arr.push(module)
          }
          this.setState({collapsedLinks:arr})*/

        // moze byc tylko jedno rozwiniete

        this.setState({collapsedLinks: [module]})

    }

    render() {
        return (
            <div>
                <Router>
                    <Switch>

                        {/*
                            główne widoki
                        */}

                        <Route exact path="/" render={(props) => Boolean(LogowanieService.sprawdzCzyZalogowany()) ?

                            LogowanieService.sprawdzCzyToUrzad() ?
                                <UrzadBiletyJednorazoweContainer  {...props} obecnyKalendarz={this.state.obecnyKalendarz}
                                                                  collapsedLinks={this.state.collapsedLinks}
                                                                  handleClickToogleSidebar={this.handleClickToogleSidebar}/>
                                :
                                <HomeContainer  {...props} obecnyKalendarz={this.state.obecnyKalendarz} collapsedLinks={this.state.collapsedLinks}
                                                handleClickToogleSidebar={this.handleClickToogleSidebar}/>
                            :
                            <LogowanieContainer  {...props}/>}/>


                        <Route exact path="/home" render={(props) => Boolean(LogowanieService.sprawdzCzyZalogowany()) ?
                            <HomeContainer  {...props} obecnyKalendarz={this.state.obecnyKalendarz} collapsedLinks={this.state.collapsedLinks}
                                            handleClickToogleSidebar={this.handleClickToogleSidebar}/>
                            :
                            <LogowanieContainer  {...props}/>}/>

                        <Route exact path="/logowanie" render={(props) => Boolean(!LogowanieService.sprawdzCzyZalogowany()) ?
                            <LogowanieContainer  {...props} obecnyKalendarz={this.state.obecnyKalendarz} collapsedLinks={this.state.collapsedLinks}/>
                            :

                            LogowanieService.sprawdzCzyToUrzad() ?
                                <UrzadBiletyJednorazoweContainer  {...props} obecnyKalendarz={this.state.obecnyKalendarz}
                                                                  collapsedLinks={this.state.collapsedLinks}
                                                                  handleClickToogleSidebar={this.handleClickToogleSidebar}/>
                                :
                                <HomeContainer  {...props} obecnyKalendarz={this.state.obecnyKalendarz} collapsedLinks={this.state.collapsedLinks}
                                                handleClickToogleSidebar={this.handleClickToogleSidebar}/>}/>

                        {/*
                            zarządzanie trasami
                        */}

                        <Route exact path="/konfiguracja/zarzadzanie-trasami/miejscowosci"
                               render={(props) => Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/konfiguracja/zarzadzanie-trasami/miejscowosci"))) ?
                                   <MiejscowosciContainer  {...props} obecnyKalendarz={this.state.obecnyKalendarz}
                                                           collapsedLinks={this.state.collapsedLinks}
                                                           handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                   <Redirect to={'/'}/>}/>
                        <Route exact path="/konfiguracja/zarzadzanie-trasami/przystanki"
                               render={(props) => Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/konfiguracja/zarzadzanie-trasami/przystanki"))) ?
                                   <PrzystankiContainer  {...props} obecnyKalendarz={this.state.obecnyKalendarz}
                                                         collapsedLinks={this.state.collapsedLinks}
                                                         handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                   <Redirect to={'/'}/>}/>
                        <Route exact path="/konfiguracja/zarzadzanie-trasami/trasy"
                               render={(props) => Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/konfiguracja/zarzadzanie-trasami/trasy"))) ?
                                   <TrasyContainer  {...props} obecnyKalendarz={this.state.obecnyKalendarz} collapsedLinks={this.state.collapsedLinks}
                                                    handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                   <Redirect to={'/'}/>}/>
                        <Route exact path="/konfiguracja/zarzadzanie-trasami/linie"
                               render={(props) => Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/konfiguracja/zarzadzanie-trasami/linie"))) ?
                                   <LinieContainer  {...props} obecnyKalendarz={this.state.obecnyKalendarz} collapsedLinks={this.state.collapsedLinks}
                                                    handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                   <Redirect to={'/'}/>}/>
                        <Route exact path="/konfiguracja/zarzadzanie-trasami/definicje"
                               render={(props) => Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/konfiguracja/zarzadzanie-trasami/definicje"))) ?
                                   <DefinicjeContainer  {...props} obecnyKalendarz={this.state.obecnyKalendarz}
                                                        collapsedLinks={this.state.collapsedLinks}
                                                        handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                   <Redirect to={'/'}/>}/>
                        <Route exact path="/konfiguracja/zarzadzanie-trasami/przystanki-na-trasie"
                               render={(props) => Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/konfiguracja/zarzadzanie-trasami/przystanki-na-trasie"))) ?
                                   <DefinicjeTrasContainer  {...props} obecnyKalendarz={this.state.obecnyKalendarz}
                                                            collapsedLinks={this.state.collapsedLinks}
                                                            handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                   <Redirect to={'/'}/>}/>
                        <Route exact path="/konfiguracja/zarzadzanie-trasami/eprzystanki"
                               render={(props) => Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/konfiguracja/zarzadzanie-trasami/eprzystanki"))) ?
                                   <EPrzystankiContainer  {...props} obecnyKalendarz={this.state.obecnyKalendarz}
                                                          collapsedLinks={this.state.collapsedLinks}
                                                          handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                   <Redirect to={'/'}/>}/>

                        {/*
                            zasoby
                        */}

                        <Route exact path="/konfiguracja/zarzadzanie-zasobami/pojazdy"
                               render={(props) => Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/konfiguracja/zarzadzanie-zasobami/pojazdy"))) ?
                                   <PojazdyContainer  {...props} obecnyKalendarz={this.state.obecnyKalendarz}
                                                      collapsedLinks={this.state.collapsedLinks}
                                                      handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                   <Redirect to={'/'}/>}/>
                        <Route exact path="/konfiguracja/zarzadzanie-zasobami/kierowcy"
                               render={(props) => Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/konfiguracja/zarzadzanie-zasobami/kierowcy"))) ?
                                   <KierowcyContainer {...props} obecnyKalendarz={this.state.obecnyKalendarz}
                                                      collapsedLinks={this.state.collapsedLinks}
                                                      handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                   <Redirect to={'/'}/>}/>
                        <Route exact path="/konfiguracja/zarzadzanie-zasobami/ekipy"
                               render={(props) => Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/konfiguracja/zarzadzanie-zasobami/ekipy"))) ?
                                   <EkipyContainer  {...props} obecnyKalendarz={this.state.obecnyKalendarz} collapsedLinks={this.state.collapsedLinks}
                                                    handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                   <Redirect to={'/'}/>}/>
                        <Route path="/konfiguracja/zarzadzanie-zasobami/ekipy/:ekipaId"
                               render={(props) => Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/konfiguracja/zarzadzanie-zasobami/ekipy/:ekipaId"))) ?
                                   <EkipaContainer  {...props} obecnyKalendarz={this.state.obecnyKalendarz} collapsedLinks={this.state.collapsedLinks}
                                                    handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                   <Redirect to={'/'}/>}/>

                        {/*
                            rozkład jazdy
                        */}

                        <Route exact path="/konfiguracja/rozklad-jazdy/kalendarze"
                               render={(props) => Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/konfiguracja/rozklad-jazdy/kalendarze"))) ?
                                   <KalendarzeContainer  {...props} obecnyKalendarz={this.state.obecnyKalendarz}
                                                         collapsedLinks={this.state.collapsedLinks}
                                                         handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                   <Redirect to={'/'}/>}/>
                        <Route exact path="/konfiguracja/rozklad-jazdy/godziny-startowe"
                               render={(props) => Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/konfiguracja/rozklad-jazdy/godziny-startowe"))) ?
                                   <DefinicjaGodzinyStartowejContainer  {...props} obecnyKalendarz={this.state.obecnyKalendarz}
                                                                        collapsedLinks={this.state.collapsedLinks}
                                                                        handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                   <Redirect to={'/'}/>}/>
                        <Route exact path="/konfiguracja/rozklad-jazdy/rozklad"
                               render={(props) => Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/konfiguracja/rozklad-jazdy/rozklad"))) ?
                                   <RozkladContainer  {...props} obecnyKalendarz={this.state.obecnyKalendarz}
                                                      collapsedLinks={this.state.collapsedLinks}
                                                      handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                   <Redirect to={'/'}/>}/>
                        <Route exact path="/konfiguracja/rozklad-jazdy/obsada"
                               render={(props) => Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/konfiguracja/rozklad-jazdy/obsada"))) ?
                                   <ObsadaContainer {...props} obecnyKalendarz={this.state.obecnyKalendarz} collapsedLinks={this.state.collapsedLinks}
                                                    handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                   <Redirect to={'/'}/>}/>
                        <Route exact path="/konfiguracja/rozklad-jazdy/sprawdz"
                               render={(props) => Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/konfiguracja/rozklad-jazdy/sprawdz"))) ?
                                   <SprawdzKonfiguracjeContainer  {...props} obecnyKalendarz={this.state.obecnyKalendarz}
                                                                  collapsedLinks={this.state.collapsedLinks}
                                                                  handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                   <Redirect to={'/'}/>}/>
                        <Route exact path="/konfiguracja/rozklad-jazdy/szukaj"
                               render={(props) => Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/konfiguracja/rozklad-jazdy/szukaj"))) ?
                                   <SzukajContainer  {...props} obecnyKalendarz={this.state.obecnyKalendarz}
                                                     collapsedLinks={this.state.collapsedLinks}
                                                     handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                   <Redirect to={'/'}/>}/>
                        <Route exact path="/konfiguracja/rozklad-jazdy/lokalizacja"
                               render={(props) => Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/konfiguracja/rozklad-jazdy/lokalizacja"))) ?
                                   <LokalizacjaBusowContainer  {...props} obecnyKalendarz={this.state.obecnyKalendarz}
                                                               collapsedLinks={this.state.collapsedLinks}
                                                               handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                   <Redirect to={'/'}/>}/>

                        {/*
                            bilety
                        */}


                        <Route exact path="/konfiguracja/zarzadzanie-biletami/bilety/dodaj-jednorazowy"
                               render={(props) => Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/konfiguracja/zarzadzanie-biletami/bilety/dodaj-jednorazowy"))) ?
                                   <DodajBiletJednorazowyContainer  {...props} obecnyKalendarz={this.state.obecnyKalendarz}
                                                                    collapsedLinks={this.state.collapsedLinks}
                                                                    handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                   <Redirect to={'/'}/>}/>
                        <Route exact path="/konfiguracja/zarzadzanie-biletami/bilety-jednorazowe"
                               render={(props) => Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/konfiguracja/zarzadzanie-biletami/bilety-jednorazowe"))) ?
                                   <BiletyJednorazoweContainer  {...props} obecnyKalendarz={this.state.obecnyKalendarz}
                                                                collapsedLinks={this.state.collapsedLinks}
                                                                handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                   <Redirect to={'/'}/>}/>
                        <Route exact path="/konfiguracja/zarzadzanie-biletami/bilety/dodaj-miesieczny"
                               render={(props) => Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/konfiguracja/zarzadzanie-biletami/bilety/dodaj-miesieczny"))) ?
                                   <DodajBiletMiesiecznyContainer  {...props} obecnyKalendarz={this.state.obecnyKalendarz}
                                                                   collapsedLinks={this.state.collapsedLinks}
                                                                   handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                   <Redirect to={'/'}/>}/>
                        <Route path="/konfiguracja/zarzadzanie-biletami/bilety/dodaj-miesieczny/:nrKarty"
                               render={(props) => Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/konfiguracja/zarzadzanie-biletami/bilety/dodaj-miesieczny"))) ?
                                   <DodajBiletMiesiecznyContainer  {...props} obecnyKalendarz={this.state.obecnyKalendarz}
                                                                   collapsedLinks={this.state.collapsedLinks}
                                                                   handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                   <Redirect to={'/'}/>}/>
                        <Route exact path="/konfiguracja/zarzadzanie-biletami/bilety-miesieczne"
                               render={(props) => Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/konfiguracja/zarzadzanie-biletami/bilety-miesieczne"))) ?
                                   <BiletyMiesieczneContainer  {...props} obecnyKalendarz={this.state.obecnyKalendarz}
                                                               collapsedLinks={this.state.collapsedLinks}
                                                               handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                   <Redirect to={'/'}/>}/>
                        <Route exact path="/konfiguracja/zarzadzanie-biletami/faktury"
                               render={(props) => Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/konfiguracja/zarzadzanie-biletami/faktury"))) ?
                                   <FakturyBiletyContainer  {...props} obecnyKalendarz={this.state.obecnyKalendarz}
                                                            collapsedLinks={this.state.collapsedLinks}
                                                            handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                   <Redirect to={'/'}/>}/>
                        <Route exact path="/konfiguracja/zarzadzanie-biletami/eplatnosci"
                               render={(props) => Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/konfiguracja/zarzadzanie-biletami/eplatnosci"))) ?
                                   <EplatnosciContainer  {...props} obecnyKalendarz={this.state.obecnyKalendarz}
                                                         collapsedLinks={this.state.collapsedLinks}
                                                         handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                   <Redirect to={'/'}/>}/>
                        <Route exact path="/konfiguracja/zarzadzanie-biletami/ceny-biletow"
                               render={(props) => Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/konfiguracja/zarzadzanie-biletami/ceny-biletow"))) ?
                                   <CenyBiletowContainer  {...props} obecnyKalendarz={this.state.obecnyKalendarz}
                                                          collapsedLinks={this.state.collapsedLinks}
                                                          handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                   <Redirect to={'/'}/>}/>
                        <Route exact path="/konfiguracja/zarzadzanie-biletami/znizki"
                               render={(props) => Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/konfiguracja/zarzadzanie-biletami/znizki"))) ?
                                   <ZnizkiContainer  {...props} obecnyKalendarz={this.state.obecnyKalendarz}
                                                     collapsedLinks={this.state.collapsedLinks}
                                                     handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                   <Redirect to={'/'}/>}/>
                        <Route exact path="/konfiguracja/zarzadzanie-biletami/promocje"
                               render={(props) => Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/konfiguracja/zarzadzanie-biletami/promocje"))) ?
                                   <PromocjeContainer  {...props} obecnyKalendarz={this.state.obecnyKalendarz}
                                                       collapsedLinks={this.state.collapsedLinks}
                                                       handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                   <Redirect to={'/'}/>}/>


                        {/*
                            klienci
                        */}

                        <Route exact path="/konfiguracja/zarzadzanie-klientami/karty"
                               render={(props) => Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/konfiguracja/zarzadzanie-klientami/karty"))) ?
                                   <KartyContainer  {...props} obecnyKalendarz={this.state.obecnyKalendarz} collapsedLinks={this.state.collapsedLinks}
                                                    handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                   <Redirect to={'/'}/>}/>
                        <Route exact path="/zarzadzanie-klientami/klienci"
                               render={(props) => Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/zarzadzanie-klientami/klienci"))) ?
                                   <KlienciContainer  {...props} obecnyKalendarz={this.state.obecnyKalendarz}
                                                      collapsedLinks={this.state.collapsedLinks}
                                                      handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                   <Redirect to={'/'}/>}/>
                        <Route exact path="/zarzadzanie-klientami/klient/:idKl"
                               render={(props) => Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/zarzadzanie-klientami/klient/:idKl"))) ?
                                   <StronaKlientaContainer  {...props} obecnyKalendarz={this.state.obecnyKalendarz}
                                                            collapsedLinks={this.state.collapsedLinks}
                                                            handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                   <Redirect to={'/'}/>}/>
                        <Route exact path="/zarzadzanie-klientami/firmy"
                               render={(props) => Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/zarzadzanie-klientami/firmy"))) ?
                                   <FirmyContainer  {...props} obecnyKalendarz={this.state.obecnyKalendarz} collapsedLinks={this.state.collapsedLinks}
                                                    handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                   <Redirect to={'/'}/>}/>
                        <Route exact path="/zarzadzanie-klientami/oceny"
                               render={(props) => Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/zarzadzanie-klientami/oceny"))) ?
                                   <OcenyContainer  {...props} obecnyKalendarz={this.state.obecnyKalendarz} collapsedLinks={this.state.collapsedLinks}
                                                    handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                   <Redirect to={'/'}/>}/>
                        <Route exact path="/zarzadzanie-klientami/ebok"
                               render={(props) => Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/zarzadzanie-klientami/ebok"))) ?
                                   <EBOKContainer  {...props} obecnyKalendarz={this.state.obecnyKalendarz} collapsedLinks={this.state.collapsedLinks}
                                                   handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                   <Redirect to={'/'}/>}/>
                        <Route exact path="/zarzadzanie-klientami/ebok/zgloszenie/:zgloszenieId"
                               render={(props) => Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/zarzadzanie-klientami/ebok/zgloszenie/:zgloszenieId"))) ?
                                   <EBOKWatekContainer  {...props} obecnyKalendarz={this.state.obecnyKalendarz}
                                                        collapsedLinks={this.state.collapsedLinks}
                                                        handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                   <Redirect to={'/'}/>}/>
                        <Route exact path="/zarzadzanie-klientami/eventy"
                               render={(props) => Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/zarzadzanie-klientami/eventy"))) ?
                                   <EventyContainer  {...props} obecnyKalendarz={this.state.obecnyKalendarz}
                                                     collapsedLinks={this.state.collapsedLinks}
                                                     handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                   <Redirect to={'/'}/>}/>

                        {/*
                            wynajem
                        */}
                        <Route exact path="/konfiguracja/wynajem/lista"
                               render={(props) => Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/konfiguracja/wynajem/lista"))) ?
                                   <ZarzadzanieContainer {...props} obecnyKalendarz={this.state.obecnyKalendarz}
                                                         collapsedLinks={this.state.collapsedLinks}
                                                         handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                   <Redirect to={'/'}/>
                               }/>
                        <Route exact path="/konfiguracja/wynajem/kalendarz"
                               render={(props) => Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/konfiguracja/wynajem/kalendarz"))) ?
                                   <KalendarzContainer {...props} obecnyKalendarz={this.state.obecnyKalendarz}
                                                       collapsedLinks={this.state.collapsedLinks}
                                                       handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                   <Redirect to={'/'}/>
                               }/>
                        <Route exact path="/konfiguracja/wynajem/formularz"
                               render={(props) => Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/konfiguracja/wynajem/formularz"))) ?
                                   <FormularzContainer  {...props} obecnyKalendarz={this.state.obecnyKalendarz}
                                                        collapsedLinks={this.state.collapsedLinks}
                                                        handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                   <Redirect to={'/'}/>
                               }/>
                        <Route path="/konfiguracja/wynajem/:id"
                               render={(props) => Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/konfiguracja/wynajem/formularz"))) ?
                                   <FormularzContainer  {...props} obecnyKalendarz={this.state.obecnyKalendarz}
                                                        collapsedLinks={this.state.collapsedLinks}
                                                        handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                   <Redirect to={'/'}/>
                               }/>

                        {/*
                            komunikaty
                        */}

                        <Route exact path="/zarzadzanie-komunikatami/newsletter"
                               render={(props) => Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/zarzadzanie-komunikatami/newsletter"))) ?
                                   <NewsletterContainer  {...props} obecnyKalendarz={this.state.obecnyKalendarz}
                                                         collapsedLinks={this.state.collapsedLinks}
                                                         handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                   <Redirect to={'/'}/>}/>
                        <Route exact path="/zarzadzanie-komunikatami/powiadomienia"
                               render={(props) => Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/zarzadzanie-komunikatami/powiadomienia"))) ?
                                   <PowiadomieniaContainer  {...props} obecnyKalendarz={this.state.obecnyKalendarz}
                                                            collapsedLinks={this.state.collapsedLinks}
                                                            handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                   <Redirect to={'/'}/>}/>

                        {/*
                            raporty
                        */}


                        <Route path="/raporty/raport-zapelnienia" render={(props) =>
                            Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/raporty/raport-zapelnienia"))) ?
                                <RaportZapelnieniaContainer  {...props} obecnyKalendarz={this.state.obecnyKalendarz}
                                                                 collapsedLinks={this.state.collapsedLinks}
                                                                 handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                <Redirect to={'/'}/>
                        }/>



                        <Route path="/raporty/sprzedaz-jednorazowych" render={(props) =>
                            Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/raporty/sprzedaz-jednorazowych"))) ?
                                <SprzedazJednorazowychContainer  {...props} obecnyKalendarz={this.state.obecnyKalendarz}
                                                                 collapsedLinks={this.state.collapsedLinks}
                                                                 handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                <Redirect to={'/'}/>
                        }/>

                        <Route path="/raporty/sprzedaz-jedn-linie" render={(props) =>
                            Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/raporty/sprzedaz-jedn-linie"))) ?
                                <SprzedazJednorazowychLiniaContainer  {...props} obecnyKalendarz={this.state.obecnyKalendarz}
                                                                      collapsedLinks={this.state.collapsedLinks}
                                                                      handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                <Redirect to={'/'}/>
                        }/>
                        <Route path="/raporty/sprzedaz-miesiecznych" render={(props) =>
                            Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/raporty/sprzedaz-miesiecznych"))) ?
                                <SprzedazMiesiecznychContainer  {...props} obecnyKalendarz={this.state.obecnyKalendarz}
                                                                collapsedLinks={this.state.collapsedLinks}
                                                                handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                <Redirect to={'/'}/>
                        }/>
                        <Route path="/raporty/sprzedaz-mies-linie" render={(props) =>
                            Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/raporty/sprzedaz-mies-linie"))) ?
                                <SprzedazMiesiecznychLiniaContainer  {...props} obecnyKalendarz={this.state.obecnyKalendarz}
                                                                     collapsedLinks={this.state.collapsedLinks}
                                                                     handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                <Redirect to={'/'}/>
                        }/>
                        <Route path="/raporty/rozliczenie-kursow" render={(props) =>
                            Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/raporty/rozliczenie-kursow"))) ?
                                <RozliczenieKursowContainer  {...props} obecnyKalendarz={this.state.obecnyKalendarz}
                                                             collapsedLinks={this.state.collapsedLinks}
                                                             handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                <Redirect to={'/'}/>
                        }/>
                        <Route path="/raporty/rozliczenia-kierowcow" render={(props) =>
                            Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/raporty/rozliczenia-kierowcow"))) ?
                                <RozliczeniaKierowcowContainer  {...props} obecnyKalendarz={this.state.obecnyKalendarz}
                                                                collapsedLinks={this.state.collapsedLinks}
                                                                handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                <Redirect to={'/'}/>
                        }/>
                        <Route path="/raporty/orlen" render={(props) =>
                            Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/raporty/orlen"))) ?
                                <OrlenContainer  {...props} obecnyKalendarz={this.state.obecnyKalendarz} collapsedLinks={this.state.collapsedLinks}
                                                 handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                <Redirect to={'/'}/>
                        }/>
                        <Route path="/raporty/ksiegowosc" render={(props) =>
                            Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/raporty/ksiegowosc"))) ?
                                <KsiegowoscContainer  {...props} obecnyKalendarz={this.state.obecnyKalendarz} collapsedLinks={this.state.collapsedLinks}
                                                 handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                <Redirect to={'/'}/>
                        }/>

                        {/*
                            administracja
                        */}

                        <Route exact path="/administracja/szablony"
                               render={(props) => Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/administracja/szablony"))) ?
                                   <SzablonyContainer  {...props} obecnyKalendarz={this.state.obecnyKalendarz}
                                                       collapsedLinks={this.state.collapsedLinks}
                                                       handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                   <Redirect to={'/'}/>}/>
                        <Route exact path="/administracja/przegladarka"
                               render={(props) => Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/administracja/przegladarka"))) ?
                                   <PrzegladarkaContainer  {...props} obecnyKalendarz={this.state.obecnyKalendarz}
                                                           collapsedLinks={this.state.collapsedLinks}
                                                           handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                   <Redirect to={'/'}/>}/>
                        <Route exact path="/administracja/faktury"
                               render={(props) => Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/administracja/faktury"))) ?
                                   <FakturyContainer  {...props} obecnyKalendarz={this.state.obecnyKalendarz}
                                                      collapsedLinks={this.state.collapsedLinks}
                                                      handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                   <Redirect to={'/'}/>}/>
                        <Route exact path="/administracja/dostep"
                               render={(props) => Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/administracja/dostep"))) ?
                                   <DostepContainer  {...props} obecnyKalendarz={this.state.obecnyKalendarz}
                                                     collapsedLinks={this.state.collapsedLinks}
                                                     handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                   <Redirect to={'/'}/>}/>
                        <Route exact path="/administracja/pracownicy"
                               render={(props) => Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/administracja/pracownicy"))) ?
                                   <PracownicyContainer  {...props} obecnyKalendarz={this.state.obecnyKalendarz}
                                                         collapsedLinks={this.state.collapsedLinks}
                                                         handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                   <Redirect to={'/'}/>}/>
                        <Route exact path="/administracja/konfiguracja"
                               render={(props) => Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/administracja/konfiguracja"))) ?
                                   <KonfiguracjaContainer  {...props} obecnyKalendarz={this.state.obecnyKalendarz}
                                                           collapsedLinks={this.state.collapsedLinks}
                                                           handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                   <Redirect to={'/'}/>}/>
                        <Route exact path="/administracja/synchronizacja"
                               render={(props) => Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/administracja/synchronizacja"))) ?
                                   <SynchronizacjaDanychContainer  {...props} obecnyKalendarz={this.state.obecnyKalendarz}
                                                                   collapsedLinks={this.state.collapsedLinks}
                                                                   handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                   <Redirect to={'/'}/>}/>
                        <Route exact path="/administracja/kierowca-serwis"
                               render={(props) => Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/administracja/kierowca-serwis"))) ?
                                   <KierowcaSerwisContainer  {...props} obecnyKalendarz={this.state.obecnyKalendarz}
                                                                   collapsedLinks={this.state.collapsedLinks}
                                                                   handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                   <Redirect to={'/'}/>}/>
                        <Route exact path="/administracja/logi"
                               render={(props) => Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/administracja/logi"))) ?
                                   <LogiContainer  {...props} obecnyKalendarz={this.state.obecnyKalendarz} collapsedLinks={this.state.collapsedLinks}
                                                   handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                   <Redirect to={'/'}/>}/>

                        {/*
                            urzad
                        */}

                        <Route path="/urzad/rozklad" render={(props) =>
                            Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/urzad/rozklad"))) ?
                                <UrzadRozkladContainer  {...props} obecnyKalendarz={this.state.obecnyKalendarz}
                                                        collapsedLinks={this.state.collapsedLinks}
                                                        handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                <Redirect to={'/'}/>
                        }/>
                        <Route path="/urzad/jednorazowe" render={(props) =>
                            Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/urzad/jednorazowe"))) ?
                                <UrzadBiletyJednorazoweContainer  {...props} obecnyKalendarz={this.state.obecnyKalendarz}
                                                                  collapsedLinks={this.state.collapsedLinks}
                                                                  handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                <Redirect to={'/'}/>
                        }/>
                        <Route path="/urzad/miesieczne" render={(props) =>
                            Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/urzad/miesieczne"))) ?
                                <UrzadBiletyMiesieczneContainer  {...props} obecnyKalendarz={this.state.obecnyKalendarz}
                                                                 collapsedLinks={this.state.collapsedLinks}
                                                                 handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                <Redirect to={'/'}/>
                        }/>
                        <Route path="/urzad/raport-cenniki" render={(props) =>
                            Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/urzad/raport-cenniki"))) ?
                                <UrzadRaportCennikow  {...props} obecnyKalendarz={this.state.obecnyKalendarz}
                                                      collapsedLinks={this.state.collapsedLinks}
                                                      handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                <Redirect to={'/'}/>
                        }/>
                        <Route path="/urzad/raport-linie" render={(props) =>
                            Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/urzad/raport-linie"))) ?
                                <UrzadRaportPoLiniach  {...props} obecnyKalendarz={this.state.obecnyKalendarz}
                                                       collapsedLinks={this.state.collapsedLinks}
                                                       handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                <Redirect to={'/'}/>
                        }/>
                        <Route path="/urzad/raport-sumaryczny" render={(props) =>
                            Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/urzad/raport-sumaryczny"))) ?
                                <UrzadRaportSumaryczny  {...props} obecnyKalendarz={this.state.obecnyKalendarz}
                                                       collapsedLinks={this.state.collapsedLinks}
                                                       handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                <Redirect to={'/'}/>
                        }/>
                        <Route path="/urzad/raport-doplat-grup" render={(props) =>
                            Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/urzad/raport-doplat-grup"))) ?
                                <UrzadRaportDoplatGrup  {...props} obecnyKalendarz={this.state.obecnyKalendarz}
                                                       collapsedLinks={this.state.collapsedLinks}
                                                       handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                <Redirect to={'/'}/>
                        }/>
                        <Route path="/urzad/raport-doplat-suma" render={(props) =>
                            Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/urzad/raport-doplat-suma"))) ?
                                <UrzadRaportDoplatSuma  {...props} obecnyKalendarz={this.state.obecnyKalendarz}
                                                       collapsedLinks={this.state.collapsedLinks}
                                                       handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                <Redirect to={'/'}/>
                        }/>

                        {/*

                            ********** aplikacje na androida **********

                        */}

                        <Route path="/aplikacjeandroid/ebus-driver" render={(props) =>
                            Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/aplikacjeandroid/ebus-driver"))) ?
                                <AplikacjaEbusDriver  {...props} obecnyKalendarz={this.state.obecnyKalendarz}
                                                       collapsedLinks={this.state.collapsedLinks}
                                                       handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                <Redirect to={'/'}/>
                        }/>

                        <Route path="/aplikacjeandroid/aplikacja-kliencka" render={(props) =>
                            Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/aplikacjeandroid/aplikacja-kliencka"))) ?
                                <AplikacjaDlaKlientow  {...props} obecnyKalendarz={this.state.obecnyKalendarz}
                                                       collapsedLinks={this.state.collapsedLinks}
                                                       handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                <Redirect to={'/'}/>
                        }/>

                        {/*

                            ********** LPP **********

                        */}

                        <Route path="/lpp/odbicia" render={(props) =>
                            Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/lpp/odbicia"))) ?
                                <Odbicia  {...props} obecnyKalendarz={this.state.obecnyKalendarz}
                                                      collapsedLinks={this.state.collapsedLinks}
                                                      handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                <Redirect to={'/'}/>
                        }/>


                        {/*
                            ************ pozostale ************
                        */}

                        <Route path="/faktura"
                               render={(props) => Boolean(LogowanieService.sprawdzCzyZalogowanyPosiadaRole(accessConfig.checkAccessToUrl("/faktura"))) ?
                                   <FakturaContainer  {...props} obecnyKalendarz={this.state.obecnyKalendarz}
                                                      collapsedLinks={this.state.collapsedLinks}
                                                      handleClickToogleSidebar={this.handleClickToogleSidebar}/> :
                                   <Redirect to={'/'}/>
                               }/>

                        <Redirect to="/"/>
                    </Switch>
                </Router>
                <NotificationContainer/>
            </div>

        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js